<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-07-10 13:48:42
-->
<template>
    <div>
        <a-sub-menu :key="subMenu.key" :popup-max-height="300">
            <template #icon>
                <component :is="$arcoVueIcon[subMenu.icon]" :size="17"></component>
            </template>
            <template #title>{{ $t(`${subMenu.locale}`) }}</template>
            <template v-for="item in subMenu.children" :key="item.key">
                <template v-if="!item.children">
                    <router-link :to="item.link">
                        <a-menu-item :key="item.key">
                            <template #icon>
                                <component :is="$arcoVueIcon[item.icon]" :size="17"></component>
                            </template>
                            {{ $t(`${item.locale}`) }}
                        </a-menu-item>
                    </router-link>
                </template>
                <template v-else>
                    <subMenu :key="item.key" :subMenu="item"></subMenu>
                </template>
            </template>
        </a-sub-menu>
    </div>
</template>

<script setup>
    import { ref } from 'vue';

    const props = defineProps({
        subMenu:{
            type:Array,
            default:()=>[]
        }
    })
</script>

<style lang="less" scoped>
// 只调整二级菜单项的高度
/deep/ .arco-menu-sub {
    .arco-menu-item {
        padding: 4px 5px 4px 15px !important;
        font-size: 11px !important;
        line-height: 1.2 !important;
        min-height: 30px !important;
        height: 30px !important;
    }
    
    .arco-menu-item-icon {
        margin-right: 6px;
        font-size: 14px;
    }
}

// 一级菜单标题保持原始高度，不做修改

</style>